import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AccountSelectors } from '@recruitee/account';
import { filterBoolean } from '@recruitee/common';
import type { Company } from '@recruitee/company-types';

@Injectable({
  providedIn: 'root',
})
export class InterviewPreviewService {
  private company: Company | null = null;
  constructor(private store: Store) {
    this.store
      .select(AccountSelectors.currentCompany)
      .pipe(filterBoolean)
      .subscribe((company: Company) => (this.company = company));
  }

  public generateLinkTemplate(token: string): string {
    if (this.company) {
      const { host } = this.company;

      return `https://${host}/v/i/t/${token}/no-token`;
    }

    throw new Error(
      'Something went terribly wrong! We just tried generating interview preview link for non-existing company!',
    );
  }
}
